module.exports = __webpack_public_path__ + "static/media/inverted_triangle_bodytype.22edb5dd.png";